import Dropdown from './dropdown';
Dropdown.install = function (app) {
    app.component(Dropdown.name, Dropdown);
    app.component(Dropdown.Item.name, Dropdown.Item);
    return app;
};
export default Dropdown;
